import { render, staticRenderFns } from "./HabilitationAction.vue?vue&type=template&id=0223ec00&scoped=true"
import script from "./HabilitationAction.vue?vue&type=script&lang=js"
export * from "./HabilitationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223ec00",
  null
  
)

export default component.exports